import InitialAnimation from "components/InitialAnimation";
import SEO from "components/SEO";
import React from "react";
import { useTranslation } from "react-i18next";
import BackedBy from "./BackedBy";
import BannerAnalyse from "./BannerAnalyse";
import Capacity from "./Capacity";
import Hero from "./Hero";
import HowItWorks from "./HowItWorks";
import JoinUs from "./JoinUs";
import Partners from "./Partners";

function HomePage() {
  const { t } = useTranslation("home");
  return (
    <>
      <SEO title={t("meta.title")} description={t("meta.description")} path="/" />
      <Hero />
      <Partners />
      <BannerAnalyse />
      <HowItWorks />
      <Capacity />
      <BackedBy />
      <JoinUs />
      <InitialAnimation />
    </>
  );
}

export default HomePage;
